// 转跳到相应的节点
let cutToNode = function (node) {
    // 参数支持ID和Node节点
    if (typeof node === 'string' || typeof node === 'number') {
        node = this.data.nodes.find(_ => _.id.includes(node));
    }
    const distance = 175;
    const distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z);
    let duration = 3000;
    this.Graph.cameraPosition(
        // { x: node.x, y: node.y, z: node.z }, // new position

        { x: node.x * distRatio, y: node.y * distRatio, z: node.z * distRatio }, // new position
        node, // lookAt ({ x, y, z })
        duration  // ms transition duration
    );
    // console.log('-------------');
    // 不转跳
    // if (node.depth === '0') {
    //     this.eventBus.$emit('3d-to-2d', node, duration);

    //     // TODO 定时器清理
    //     setTimeout(() => {
    //     }, duration)
    // }
};

export default cutToNode;
